import { Tooltip } from "@octopusdeploy/design-system-components";
import type { KubernetesLiveApplicationStatusCode } from "@octopusdeploy/octopus-server-client";
import React from "react";
import * as LiveAppStatusIcon from "./LiveAppIcons";
interface LiveStatusIconProps {
    status: KubernetesLiveApplicationStatusCode;
    size: LiveAppStatusIcon.LiveStatusIconSize;
}
const LiveStatusToVisuals = (status: KubernetesLiveApplicationStatusCode, size: LiveAppStatusIcon.LiveStatusIconSize): JSX.Element => {
    switch (status) {
        case "OutOfSync":
            return <Tooltip content={"Desired state on the cluster is different from the desired state applied"}>{LiveAppStatusIcon.OutOfSyncIcon(size)}</Tooltip>;
        case "Progressing":
            return <Tooltip content={"Some objects are in a progressing state"}>{LiveAppStatusIcon.ProgressingIcon(size)}</Tooltip>;
        case "Degraded":
            return <Tooltip content={"Desired state not achieved and the application has encountered issues"}>{LiveAppStatusIcon.DegradedIcon(size)}</Tooltip>;
        case "Missing":
            return <Tooltip content={"The application has missing objects"}>{LiveAppStatusIcon.MissingIcon(size)}</Tooltip>;
        case "Healthy":
            return <Tooltip content={"The application's desired state was achieved"}>{LiveAppStatusIcon.HealthyIcon(size)}</Tooltip>;
        case "Unavailable":
            return <Tooltip content={"Application live status is unavailable because your last deployment failed"}>{LiveAppStatusIcon.UnavailableIcon(size)}</Tooltip>;
        case "Waiting":
            return <Tooltip content={"A deployment is in progress"}>{LiveAppStatusIcon.WaitingIcon(size)}</Tooltip>;
        case "Unknown":
        default:
            return <Tooltip content={"The application has objects in an unknown state."}>{LiveAppStatusIcon.UnknownIcon(size)}</Tooltip>;
    }
};
export const LiveStatusIcon = (props: LiveStatusIconProps) => {
    if (props.status === "NotSupported") {
        return <></>;
    }
    return LiveStatusToVisuals(props.status, props.size);
};
